var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import AddBlock from './addblock';
import { CourseNearLessonBlock } from './postblocks/CourseBlock/courseNearLessonBlock';
import useCommonProps from '../../../hooks/useCommonProps';
import { useGetLesson } from '../../../hooks/api/useGetLesson';
export var LessonConditionalAddBlockWrapper = function (_a) {
    var _b;
    var addBlockProps = _a.addBlockProps, lessonBlockProps = _a.lessonBlockProps;
    var isEditable = useCommonProps().isEditable;
    var _c = useGetLesson((_b = lessonBlockProps === null || lessonBlockProps === void 0 ? void 0 : lessonBlockProps.post) === null || _b === void 0 ? void 0 : _b.text), lesson = _c[0], isLoading = _c[1];
    if (isLoading) {
        return null;
    }
    if ((lesson === null || lesson === void 0 ? void 0 : lesson.text) === 'LESSON_CONTENT_MASK') {
        return (React.createElement("div", { style: {
                padding: '20px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                margin: '10px 0',
                textAlign: 'center'
            } },
            React.createElement("div", { style: {
                    color: '#6c757d',
                    fontSize: '16px',
                    fontWeight: '500'
                } }, "\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u044D\u0442\u043E\u043C\u0443 \u0443\u0440\u043E\u043A\u0443 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D"),
            React.createElement("div", { style: {
                    color: '#868e96',
                    fontSize: '14px',
                    marginTop: '8px'
                } }, "\u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443 \u043A\u0443\u0440\u0441\u0430 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430")));
    }
    return (React.createElement("div", null,
        isEditable && React.createElement(AddBlock, __assign({}, addBlockProps)),
        React.createElement(CourseNearLessonBlock, __assign({}, lessonBlockProps, { lesson: lesson, isLoading: isLoading }))));
};
//# sourceMappingURL=LessonConditionalAddBlockWrapper.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import AddBlock from './addblock';
import { CourseNearLessonBlock } from './postblocks/CourseBlock/courseNearLessonBlock';
import useCommonProps from '../../../hooks/useCommonProps';
import { useGetLesson } from '../../../hooks/api/useGetLesson';
export var LessonConditionalAddBlockWrapper = function (_a) {
    var _b;
    var addBlockProps = _a.addBlockProps, lessonBlockProps = _a.lessonBlockProps;
    var isEditable = useCommonProps().isEditable;
    var _c = useGetLesson((_b = lessonBlockProps === null || lessonBlockProps === void 0 ? void 0 : lessonBlockProps.post) === null || _b === void 0 ? void 0 : _b.text), lesson = _c[0], isLoading = _c[1];
    if (isLoading) {
        return null;
    }
    if ((lesson === null || lesson === void 0 ? void 0 : lesson.text) === 'LESSON_CONTENT_MASK') {
        return (React.createElement("div", { style: {
                padding: '20px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                margin: '10px 0',
                textAlign: 'center'
            } },
            React.createElement("div", { style: {
                    color: '#6c757d',
                    fontSize: '16px',
                    fontWeight: '500'
                } }, "\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u044D\u0442\u043E\u043C\u0443 \u0443\u0440\u043E\u043A\u0443 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D"),
            React.createElement("div", { style: {
                    color: '#868e96',
                    fontSize: '14px',
                    marginTop: '8px'
                } }, "\u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443 \u043A\u0443\u0440\u0441\u0430 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430")));
    }
    return (React.createElement("div", null,
        isEditable && React.createElement(AddBlock, __assign({}, addBlockProps)),
        React.createElement(CourseNearLessonBlock, __assign({}, lessonBlockProps, { lesson: lesson, isLoading: isLoading }))));
};
//# sourceMappingURL=LessonConditionalAddBlockWrapper.js.map